<template>
    <div class="d-flex flex-md-row flex-column justify-content-md-center text-black mobile-background">
        <div class="two-column-information">
            <div class="d-flex flex-row justify-content-md-start justify-content-center game-data-header">
                GAME DATA
            </div>
            <div class="inside-info windows-command-prompt">
                <div class="d-flex flex-row justify-content-md-start justify-content-center">
                    Total chicken minted: {{totalChickenMinted}}
                </div>
                <div class="d-flex flex-row justify-content-md-start justify-content-center">
                    Total chicken staked: {{totalChickenStaked}}
                </div>
                <div class="d-flex flex-row justify-content-md-start justify-content-center">
                    Total snake minted: {{totalSnakeMinted}}
                </div>
                <div class="d-flex flex-row justify-content-md-start justify-content-center">
                    Total snake staked: {{totalSnakeStaked}}
                </div>
                <div class="d-flex flex-row justify-content-md-start justify-content-center">
                    Total rooster minted: {{totalRoosterMinted}}
                </div>
                <div class="d-flex flex-row justify-content-md-start justify-content-center">
                    Total rooster staked: {{totalRoosterStaked}}
                </div>
                <div class="d-flex flex-row justify-content-md-start justify-content-center">
                    Chicken kidnap: {{chickenKidnap}}
                </div>
                <div class="d-flex flex-row justify-content-md-start justify-content-center">
                    Snake kidnap: {{snakeKidnap}}
                </div>
            </div>
        </div>
        <div class="two-column-information">
            <div class="d-flex flex-row justify-content-md-start justify-content-center game-data-header">
                LEADERBOARD
            </div>
            <div class="inside-info windows-command-prompt">
                <div class="d-flex flex-row justify-content-md-start justify-content-center">
                    #1 name1 
                </div>
                <div class="d-flex flex-row justify-content-md-start justify-content-center">
                    #2 name2 
                </div>
                <div class="d-flex flex-row justify-content-md-start justify-content-center">
                    #3 name3 
                </div>
                <div class="d-flex flex-row justify-content-md-start justify-content-center">
                    #4 name4 
                </div>
                <div class="d-flex flex-row justify-content-md-start justify-content-center">
                    #5 name5 
                </div>
                <div class="d-flex flex-row justify-content-md-start justify-content-center">
                    #6 name6 
                </div>
                <div class="d-flex flex-row justify-content-md-start justify-content-center">
                    #7 name7 
                </div>
                <div class="d-flex flex-row justify-content-md-start justify-content-center">
                    #8 name8 
                </div>
                <div class="d-flex flex-row justify-content-md-start justify-content-center">
                    #9 name9 
                </div>
                <div class="d-flex flex-row justify-content-md-start justify-content-center">
                    #10 name10 
                </div>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    name:'gamedata',
    beforeCreate(){
        document.body.className = 'gamedata';
    },
    mounted(){
        document.body.className = 'gamedata';
    },
    beforeDestroy(){
        document.body.className=''
    },
    data(){
        return{
            totalChickenMinted: 6874,
            totalChickenStaked: 6154,
            totalSnakeMinted: 1123,
            totalSnakeStaked: 1096,
            totalRoosterMinted: 30,
            totalRoosterStaked: 26,
            chickenKidnap: 45,
            snakeKidnap: 38
        }
    }
}
</script>
<style scoped>
.game-data-header{
    color: #001d69;
    font-size: 56px;
    margin-top: 120px;
}
.inside-info{
    color: black;
    font-size: 25px;
    line-height: 1.34;
}
.two-column-information{
    width: 30%;
}
@media (min-width: 1800px) {
    .two-column-information{
        width: 30%;
    }
}
@media (min-width: 2400px) {
    .two-column-information{
        width: 30%;
        margin-top: 400px;
    }
}
@media (max-width : 1200px) {
    .game-data-header{
        font-size: 40px;
        margin-top: 140px;
    }
    .inside-info{
        font-size: 20px;
    }
}
@media (max-width: 800px) {
    .two-column-information{
        width: 100%;
        padding-top: 20px !important;
    }
    .mobile-background{
        padding-top: 20px !important;
        background: url('../assets/images/bilboard-mobil.webp');
        background-size: 80% 90%;
        background-position: center;
        height: 600px;
        background-repeat: no-repeat;
    }
    .game-data-header{
        font-size: 30px;
        margin-top: 0;
    }
    .inside-info{
        font-size: 15px;
    }
}
</style>